(function () {
  'use strict';

  function initForm(form) {
    if (form.dataset.tfBound === '1') return;
    form.dataset.tfBound = '1';

    var endpoint = form.dataset.endpoint;
    var wrap = form.closest('.testimonial-form-wrap') || form.parentNode;
    var statusEl = form.querySelector('[data-status]');
    var successEl = wrap.querySelector('[data-success]');
    var submitBtn = form.querySelector('.testimonial-form__submit');
    var bodyEl = form.querySelector('textarea[name="body"]');
    var countEl = form.querySelector('[data-count]');

    // Live character counter
    if (bodyEl && countEl) {
      var updateCount = function () {
        countEl.textContent = String(bodyEl.value.length);
      };
      bodyEl.addEventListener('input', updateCount);
      updateCount();
    }

    function showStatus(message, type) {
      if (!statusEl) return;
      statusEl.hidden = false;
      statusEl.textContent = message;
      statusEl.className = 'testimonial-form__status testimonial-form__status--' + (type || 'info');
    }

    function clearStatus() {
      if (!statusEl) return;
      statusEl.hidden = true;
      statusEl.textContent = '';
    }

    function getTurnstileToken() {
      // Turnstile injects a hidden input named cf-turnstile-response.
      var input = form.querySelector('[name="cf-turnstile-response"]');
      if (input && input.value) return input.value;
      if (window.turnstile && typeof window.turnstile.getResponse === 'function') {
        try { return window.turnstile.getResponse(); } catch (e) { /* no-op */ }
      }
      return '';
    }

    function resetTurnstile() {
      if (window.turnstile && typeof window.turnstile.reset === 'function') {
        try { window.turnstile.reset(); } catch (e) { /* no-op */ }
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearStatus();

      // Native constraint validation first (required, minlength, email).
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var conditionTags = Array.prototype.slice
        .call(form.querySelectorAll('input[name="condition_tags"]:checked'))
        .map(function (el) { return el.value; });

      if (conditionTags.length === 0) {
        showStatus('Please choose at least one topic that Teeccino helped with.', 'error');
        return;
      }

      var token = getTurnstileToken();
      if (!token) {
        showStatus('Please complete the verification challenge, then submit again.', 'error');
        return;
      }

      var payload = {
        author_name: (form.elements.author_name.value || '').trim(),
        author_location: (form.elements.author_location.value || '').trim(),
        email: (form.elements.email.value || '').trim(),
        body: (form.elements.body.value || '').trim(),
        conditionTags: conditionTags,
        product: (form.elements.product.value || '').trim(),
        consent: form.elements.consent.checked,
        hp_url: (form.elements.hp_url.value || ''),
        turnstileToken: token
      };

      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      showStatus('Sending your story…', 'info');

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            return { status: response.status, data: data };
          });
        })
        .then(function (result) {
          var status = result.status;
          var data = result.data || {};

          if (status === 201 || data.ok === true) {
            form.hidden = true;
            if (successEl) {
              successEl.hidden = false;
              successEl.setAttribute('tabindex', '-1');
              successEl.focus();
            }
            return;
          }

          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          resetTurnstile();

          if (status === 429) {
            showStatus('You have submitted a few times recently. Please wait a bit and try again.', 'error');
            return;
          }

          if (status === 400) {
            var details = Array.isArray(data.details) && data.details.length
              ? ' (' + data.details.join(', ') + ')'
              : '';
            showStatus((data.error || 'Please check your entries and try again.') + details, 'error');
            return;
          }

          showStatus('Something went wrong sending your story. Please try again in a moment.', 'error');
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          resetTurnstile();
          showStatus('Network error — please check your connection and try again.', 'error');
        });
    });
  }

  function initAll() {
    var forms = document.querySelectorAll('.testimonial-form');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init for Shopify theme editor section reloads.
  document.addEventListener('shopify:section:load', initAll);
})();
